import gql from 'graphql-tag';

const GET_SPECIAL_NOTES = gql`
  query getSpecialNotesForCampaigns($skip: Int) {
    getSpecialNotesForCampaigns(skip: $skip)
  }
`;

export default GET_SPECIAL_NOTES;
